import { MoveDevice } from './MoveDevice';
import { UpdateDeviceName } from './UpdateDeviceName';

export default {
  UpdateDeviceName,
  MoveDevice,
};
